<template>


    <div class="settings">
        <div class="topbar__settings">
            <ul>
                <li :class="{'active': active==1}" @click="active=1">Audio</li>
                <li :class="{'active': active==2}" @click="active=2">Camera</li>
                <li :class="{'active': active==3}" @click="active=3">General</li>
            </ul>
        </div>
        <div class="set__settings" v-if="active==1">
            <h4>Microphone</h4>
            <div class="d-flex justify-content-between align-items-center ">
                <select class="form-control">
                    <option value="">Internal Microphone (Built-in)</option>
                    <option value="">Internal Microphone (Built-in)</option>
                </select>
                <div>
                <span class="strength">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="mic">
                    <path d="M16.4004 4H19.0004V19.6H16.4004V4Z" fill="#DDDDDD"/>
                    <path d="M6 13.1H8.6V19.6H6V13.1Z" fill="#557EFB"/>
                    <path d="M11.2002 7.90002H13.8002V19.6H11.2002V7.90002Z" fill="#557EFB"/>
                    </svg>
                </span>
                <span class="icon" @click="mic=!mic">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12V4C8 2.93913 8.42143 1.92172 9.17157 1.17157ZM12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2Z" :fill="micFill"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9C5.55228 9 6 9.44772 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44772 4.44772 9 5 9Z" :fill="micFill"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19C11 18.4477 11.4477 18 12 18Z" :fill="micFill"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 23C7 22.4477 7.44772 22 8 22H16C16.5523 22 17 22.4477 17 23C17 23.5523 16.5523 24 16 24H8C7.44772 24 7 23.5523 7 23Z" :fill="micFill"/>
                    </svg>
                </span>
                </div>
            </div>
            <br>
            <h4>Speakers</h4>
               <div class="d-flex justify-content-between align-items-center ">
                <select class="form-control">
                    <option value="">Internal Microphone (Built-in)</option>
                    <option value="">Internal Microphone (Built-in)</option>
                </select>
                <div>
                <span class="strength" v-if="speaker">
                    Test
                </span>
                <span class="icon" @click="speaker=!speaker">
                   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.0016 12C20.0016 8.6719 17.9672 5.8219 15.0797 4.61721L14.3109 6.46409C16.4766 7.36877 18 9.50627 18 12C18 14.4985 16.4766 16.6313 14.3063 17.536L15.075 19.3828C17.9672 18.1781 20.0016 15.3281 20.0016 12ZM15.9984 12C15.9984 10.336 14.9812 8.91096 13.5375 8.31096L12.7687 10.1578C13.4906 10.4578 13.9969 11.1703 13.9969 12.0047C13.9969 12.8344 13.4906 13.5469 12.7687 13.8516L13.5375 15.6985C14.9812 15.0891 15.9984 13.6641 15.9984 12ZM16.6172 0.923462L15.8438 2.77034C19.4578 4.27502 21.9984 7.83752 21.9984 12C21.9984 16.1578 19.4578 19.725 15.8438 21.2297L16.6125 23.0766C20.9531 21.2672 24 16.9922 24 12C24 7.00784 20.9531 2.73284 16.6172 0.923462ZM0 6.99846V16.9969H5.43127L11.2404 22.0896V1.91047L5.43127 6.99846H0Z" :fill="speakerFill"/>
                    </svg>
                </span>
                </div>
            </div>
        </div>
         <div class="set__settings" v-if="active==2">
            <h4>Camera</h4>
            <div class="d-flex justify-content-between align-items-center ">
                <select class="form-control">
                    <option value="">Internal Microphone (Built-in)</option>
                    <option value="">Internal Microphone (Built-in)</option>
                </select>
                <div>
               <!-- 
                <span class="strength">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.4004 4H19.0004V19.6H16.4004V4Z" fill="#DDDDDD"/>
                    <path d="M6 13.1H8.6V19.6H6V13.1Z" fill="#557EFB"/>
                    <path d="M11.2002 7.90002H13.8002V19.6H11.2002V7.90002Z" fill="#557EFB"/>
                    </svg>
                </span>
                <span class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4V12C16 13.0609 15.5786 14.0783 14.8284 14.8284C14.0783 15.5786 13.0609 16 12 16C10.9391 16 9.92172 15.5786 9.17157 14.8284C8.42143 14.0783 8 13.0609 8 12V4C8 2.93913 8.42143 1.92172 9.17157 1.17157ZM12 2C11.4696 2 10.9609 2.21071 10.5858 2.58579C10.2107 2.96086 10 3.46957 10 4V12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V4C14 3.46957 13.7893 2.96086 13.4142 2.58579C13.0391 2.21071 12.5304 2 12 2Z" fill="#557EFB"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5 9C5.55228 9 6 9.44772 6 10V12C6 13.5913 6.63214 15.1174 7.75736 16.2426C8.88258 17.3679 10.4087 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12V10C4 9.44772 4.44772 9 5 9Z" fill="#557EFB"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C12.5523 18 13 18.4477 13 19V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V19C11 18.4477 11.4477 18 12 18Z" fill="#557EFB"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 23C7 22.4477 7.44772 22 8 22H16C16.5523 22 17 22.4477 17 23C17 23.5523 16.5523 24 16 24H8C7.44772 24 7 23.5523 7 23Z" fill="#557EFB"/>
                    </svg>
                </span>
               -->
                </div>
            </div>
            <br>
            
        </div>
         <div class="set__settings" v-if="active==3">
            <h4>Report to import this product</h4>
            <textarea  rows="3" class="form-control" placeholder="Write the issue"></textarea>
            <br>
            
        </div>
    </div>
    
</template>
<script>
export default {
    data(){
        return{
            active: 1,
            mic: true,
            speaker: true
        }
    },
    computed: {
        micFill(){
            if(this.mic){
                return "#557EFB"
            }
            return '#5b464499'
        },
        speakerFill(){
            if(this.speaker){
                return "#557EFB"
            }
            return '#5b464499'
        }
    }
}
</script>

<style lang="scss" scoped>
    .settings{
        background-color: #fff;
        padding: 16px;
        border-radius: 8px;
        max-width: 500px;
        min-width: 400px;
        .topbar__settings{
            padding: 0 20px;
            border-bottom: 1px solid #DDDDDD;
            ul{
                padding: 0;
                list-style-type: none;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 0;
                li{
                    cursor: pointer;
                    width: 33%;
                    display: inline-block;
                    text-align: center;
                    font-family: 'Nunito', sans-serif;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 22px;  
                    color: #474D52;
                    padding-bottom: 14px;
                    &.active{
                        color: #557EFB;
                        border-bottom: 2px solid #557EFB;
                    }
                    
                }
            }
        }
        .set__settings{
            padding: 18px 10px 0 10px;
            height: 165px;
           h4{
                font-family: 'Nunito',sans-serif;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 22px;
                color: #474D52;
                margin: 0;
           }
           .form-control{
               width: unset;
               border: none;
               padding-left: 0;
               margin-left: -3px;
               &:focus{
                   outline: none;
                   box-shadow: none;
               }
           }
           select {
               border: none;
               font-family: 'Nunito', sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 19px;
                color: #474D52;
               
           }
           textarea{
               width: 100% !important;
               font-family: 'Nunito', sans-serif;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 19px;
                color: #8D99A0;
           }
           .strength{
                margin-right: 10px;
                font-family: 'Nunito', sans-serif;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 19px;
                color: #557EFB;
           }
        }
    }
    @media (max-width: 560px){
    
      .settings .set__settings .form-control{
        width: 50%;
      }
    
  }
</style>